// extracted by mini-css-extract-plugin
module.exports = {"faq":"SectionFaq_faq__EtYPX","container":"SectionFaq_container__vi_u1","faq__title":"SectionFaq_faq__title__U2nDi","faq__list-container":"SectionFaq_faq__list-container__aZchs"};